import { PlatformServicesAPI, Experiments, PlatformEnvData, SessionServiceAPI } from '@wix/thunderbolt-symbols'
import { biFactory } from './bi'
import { createFedopsLoggerFactory } from './fedopsLogger'
import { platformAppBiLoggerFactory } from './biLoggerFactory'
import { monitoringFactory } from './monitoring'
import { reportTraceFactory } from './reportTrace'
import { BsiManager } from '../../bsiManagerModule'
import type { ViewerPlatformEssentials } from '@wix/fe-essentials-viewer-platform'

type createPlatformAppServicesApiParams = {
	documentData: PlatformEnvData['document']
	biData: PlatformEnvData['bi']
	appDefinitionId: string
	instanceId: string
	experiments: Experiments
	csrfToken: string
	bsiManager: BsiManager
	sessionService: SessionServiceAPI
	essentials: ViewerPlatformEssentials
}

export const createPlatformAppServicesApi = ({
	documentData,
	biData,
	appDefinitionId,
	instanceId,
	experiments,
	csrfToken,
	bsiManager,
	sessionService,
	essentials,
}: createPlatformAppServicesApiParams): PlatformServicesAPI => {
	const viewMode = biData.isPreview ? ('preview' as const) : ('site' as const)

	const bi = biFactory({ biData, viewMode, sessionService })
	const biLoggerFactory = platformAppBiLoggerFactory.createBiLoggerFactoryForApp({
		appDefinitionId,
		instanceId,
		biData,
		bsiManager,
		viewMode,
		sessionService,
		factory: essentials.biLoggerFactory,
	})
	const reportTrace = reportTraceFactory({ biData, experiments, appDefinitionId, sessionService, factory: biLoggerFactory })
	const fedOpsLoggerFactory = createFedopsLoggerFactory({ biData, viewMode, sessionService, biLoggerFactory, factory: essentials.createFedopsLogger })
	const monitoring = monitoringFactory({ url: biData.pageData.pageUrl, viewMode, viewerVersion: biData.viewerVersion, referrer: documentData.referrer })
	const appEssentials = essentials.createAppEssentials({
		appDefId: appDefinitionId,
		getLoggerForWidget: fedOpsLoggerFactory.getLoggerForWidget.bind(fedOpsLoggerFactory),
		biLoggerFactory,
	})

	return {
		getCsrfToken: () => csrfToken,
		bi,
		biLoggerFactory,
		reportTrace,
		fedOpsLoggerFactory,
		monitoring,
		essentials: appEssentials,
	}
}
